export default "__VITE_ASSET__5f6c1e77__"